module.exports = __webpack_public_path__ + "static/media/silver-badge-alt.6e485bd3.svg";